import { FC } from 'react';

import { DateCell } from './Wrapper';
import { useDateCellHandlers } from './hooks';
import { DateContainerProps } from './types';

const DateContainer: FC<DateContainerProps> = props => {
  const { handleDateClick, ...dateProps } = useDateCellHandlers(props);

  return (
    <DateCell {...dateProps} isRangeDate={props.isRangeDate} onClick={handleDateClick}>
      {props.date?.label}
    </DateCell>
  );
};

export default DateContainer;
